import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AuthenticationService } from '../../core/services/authentication.service';
import { SolicitudServicioService } from '../../core/services/solicitud-servicio.service';
import { SolicitudesService } from '../../core/services/solicitudes.service';
// Servicios
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-detallehome',
  templateUrl: './detallehome.component.html',
  styleUrls: ['./detallehome.component.css']
})

export class DetallehomeComponent implements OnInit, OnDestroy {

  private id: number;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  isDocoutUser: boolean;
  isGestionable = false;

  private subscription;
  private subscription_change;
  public bsConfig: BsDatepickerConfig;

  constructor(
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private authService: AuthenticationService,
    private utilservice: UtilitiesService,
    private solicitudesService: SolicitudServicioService
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.id = +params.get('id');
      this.SetEnviroment();
      this.InitLanguage();
    });
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['detalle'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['detalle'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values['detalle']['cabecera'] + ' #' + this.id;
    this.Description = values['detalle']['descripcion'];
    this.Hijo = values['detalle']['cabecera'];
  }

  SetEnviroment() {
    this.bsConfig = this.utilservice.getDatepickerConfig();
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    });

    this.solicitudesService.isGestionable(this.id)
      .subscribe((p) => this.isGestionable = p);
  }

  ngOnDestroy() {
    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    this.translateService = null;
    this.authService = null;
    this.utilservice = null;
  }
}
